<template lang="pug">
  v-container(grid-list-lg)
    h2.h2-header Welcome
    h5.h5-header Sign up done
    div.mt-4
      component(:is="upsaleDeal")
      
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      e1: 1,
    }
  },
  computed: {
    ...mapGetters('location', ['deals']),
    upsaleDeal() {
      if (this.deals.length === 0) {
        return 'Welcome'
      } else {
        return this.deals[0]

      }
    }
  },
  created() {
    this.loadDeals()
  },
  methods: {
    ...mapActions('location', ['loadDeals'])
  },
}
</script>

<style scoped>
.hidden {
  display: block;
}
</style>